import type { Types } from '@fiverr-private/theme';
import { AVATAR_SIZES, FONT_SIZES } from '../Avatar/constants';
import { avatarAnimation } from './style.ve.css';
import { OVERLAY_DISTANCE, LEFT_AVATARS_PADDING } from './constants';
import type { LeftAvatarsProps } from './LeftAvatars/types';

export const getAvatarGroupAvatarStyles = ({
    borderColor = 'white',
    hasAnimatedChildren,
    type,
    index,
    size,
    isMultiDigit,
}: Partial<LeftAvatarsProps> & {
    type: 'mainAvatars' | 'leftAvatars';
    index?: number;
    isMultiDigit?: boolean;
}): Types.BoxType => {
    const leftAvatarSize = size ? AVATAR_SIZES[size] : undefined;
    const marginLeft = -(OVERLAY_DISTANCE * 2);

    return {
        borderColor,
        borderStyle: 'solid',
        borderWidth: 'md',
        borderRadius: 'circle',
        userSelect: 'none',
        display: 'flex',
        position: 'relative',
        className: hasAnimatedChildren ? avatarAnimation : undefined,
        lineHeight: size ? FONT_SIZES[size] : undefined,
        fontSize: size ? FONT_SIZES[size] : undefined,
        ...(type === 'mainAvatars' && {
            style: {
                marginLeft: index === 0 ? '0px' : marginLeft,
            },
            backgroundColor: 'grey_400',
        }),
        ...(type === 'leftAvatars' && {
            justifyContent: 'center',
            alignItems: 'center',
            color: 'grey_1000',
            fontWeight: 'semibold',
            backgroundColor: 'grey_400',
            width: leftAvatarSize,
            height: leftAvatarSize,
            style: {
                marginLeft,
            },
            ...(isMultiDigit && {
                paddingX: size ? LEFT_AVATARS_PADDING[size] : undefined,
                width: undefined,
            }),
        }),
    };
};
